import { cloneDeep } from 'lodash'

import { AskResponse, Citation } from '../../api'

export type ParsedAnswer = {
  citations: Citation[]
  markdownFormatText: string
  generated_chart: string | null
} | null

export const enumerateCitations = (citations: Citation[]) => {
  const filepathMap = new Map()
  for (const citation of citations) {
    const { filepath } = citation
    let part_i = 1
    if (filepathMap.has(filepath)) {
      part_i = filepathMap.get(filepath) + 1
    }
    filepathMap.set(filepath, part_i)
    citation.part_index = part_i
  }
  return citations
}

export function parseAnswer(answer: AskResponse): ParsedAnswer {
  if (typeof answer.answer !== 'string') return null
  let answerText = answer.answer

  // Normalize the Sources header to plain text
  answerText = answerText.replace(/\*\*Sources:\*\*/g, 'Sources:').replace(/sources:/gi, 'Sources:')

  // console.log('complete answer: ', answer)
  // 1. Split out any "Sources:" section
  let sourcesText = ''
  const sourcesIndex = answerText.indexOf('Sources:')
  if (sourcesIndex !== -1) {
    sourcesText = answerText.substring(sourcesIndex)
    answerText = answerText.substring(0, sourcesIndex).trim() // Trim main answer
  }

  // 2. Parse each line from the sourcesText
  //    Lines look like: "- [Title](https://link.com)"
  const sourcesRegex = /- \[(.*?)\]\((.*?)\)/g
  const extractedSources: Citation[] = []
  let match
  while ((match = sourcesRegex.exec(sourcesText)) !== null) {
    const [_, sourceTitle, sourceUrl] = match
    extractedSources.push({
      content: '',
      id: '',
      title: sourceTitle || null,
      filepath: null,
      url: sourceUrl || null,
      metadata: null,
      chunk_id: null,
      reindex_id: null,
      part_index: 0
    })
  }

  // 3. Existing logic for doc references (if you still need it)
  const citationLinks = answerText.match(/\[(doc\d\d?\d?)]/g)
  const lengthDocN = '[doc'.length

  let filteredCitations = [] as Citation[]
  let citationReindex = 0
  citationLinks?.forEach(link => {
    const citationIndex = link.slice(lengthDocN, link.length - 1)
    const citation = cloneDeep(answer.citations[Number(citationIndex) - 1]) as Citation
    if (!filteredCitations.find(c => c.id === citationIndex) && citation) {
      answerText = answerText.replaceAll(link, ` ^${++citationReindex}^ `)
      citation.id = citationIndex
      citation.reindex_id = citationReindex.toString()
      filteredCitations.push(citation)
    }
  })

  // 4. Merge your new "extractedSources" with existing filteredCitations if desired
  const allCitations = [...filteredCitations, ...extractedSources]

  console.log('filteredCitations', filteredCitations)

  return {
    citations: allCitations,
    markdownFormatText: answerText,
    generated_chart: answer.generated_chart
  }
}
